import * as React from "react";

import { cn } from "@/lib/utils";
import { CardDescription } from "./card";

type EmptyStateProps = React.HTMLAttributes<HTMLDivElement> & {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
};

const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, title, description, icon, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("text-center py-12 space-y-3", className)}
        {...props}
      >
        {icon && <div className="flex justify-center mb-4">{icon}</div>}
        {title && (
          <CardDescription className="font-medium text-foreground text-base">
            {title}
          </CardDescription>
        )}
        {description && (
          <CardDescription className="text-sm">{description}</CardDescription>
        )}
        {children}
      </div>
    );
  }
);
EmptyState.displayName = "EmptyState";

export { EmptyState };
